import React from 'react'

import Header from "../componets/Header";
import Footer from "../componets/Footer";

import UpcommingEvents from '../componets/event-listing/UpcommingEvents';

const FutureEvents = () => {
    return (
        <>
            <div className='bs-service-page'>
                <Header />
                <UpcommingEvents />
                <Footer />
            </div>
        </>
    )
}

export default FutureEvents